import { createRequestHeaders } from '@zg-rentals/particles-js-requester';
import { shallowEqual, useSelector } from 'react-redux';

import StringConstants from '../constants/StringConstants';

import type { RestMethodNameProps } from '../constants/StringConstants';

const useRequestConfig = (methodName: RestMethodNameProps = StringConstants.GET) => {
  const {
    app: { brand, ip, userAgent, csrfToken, timeZone },
    env: { zgApi },
    user: { originalServerSideRequestCookies },
  } = useSelector(
    (state) => ({
      // @ts-expect-error
      app: state.app,
      // @ts-expect-error
      env: state.env,
      // @ts-expect-error
      user: state.user,
    }),
    shallowEqual,
  );

  const headers = __BROWSER__ ? { headers: { 'x-csrf-token': csrfToken, 'x-zone-id': timeZone } } : {};

  return {
    requestHeaders: createRequestHeaders({
      brand,
      ip,
      userAgent,
      isNode: __SERVER__,
      buildId: String(__BUILD_NUMBER__),
      method: methodName,
      cookies: originalServerSideRequestCookies,
      ...headers,
    }),
    zgApi,
    methodName,
  };
};

export default useRequestConfig;
